import axios from "axios";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";
/* eslint-disable */
export default async function getFieldDomain(
  fieldNames,
  needFields,
  url,
  token
) {
  let domains;
  const domainsObject = {};
  let results;
  try {
    results = await axios.get(url, {
      params: {
        token: token || "",
        f: "json",
      },
    });
    domains = fieldNames?.map(
      (name) =>
        results.data.fields.find((item) => item.name === name).domain
          .codedValues
    );
    if (fieldNames) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < fieldNames?.length; index++) {
        domainsObject[fieldNames[index]] = domains[index];
      }
    }
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
  const { fields } = results.data;
  if (needFields) {
    return { domains: domainsObject || {}, fields };
  }
  return domainsObject;
}
